import { render, staticRenderFns } from "./CardReportPannel.vue?vue&type=template&id=6d7603ce&scoped=true"
import script from "./CardReportPannel.vue?vue&type=script&lang=js"
export * from "./CardReportPannel.vue?vue&type=script&lang=js"
import style0 from "./CardReportPannel.vue?vue&type=style&index=0&id=6d7603ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7603ce",
  null
  
)

export default component.exports